import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
import accounts from './accounts'
import settings from './settings'
import audits from './audits'
/**
* @see \App\Http\Controllers\BrandController::index
* @see app/Http/Controllers/BrandController.php:31
* @route '/brands'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/brands',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BrandController::index
* @see app/Http/Controllers/BrandController.php:31
* @route '/brands'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BrandController::index
* @see app/Http/Controllers/BrandController.php:31
* @route '/brands'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BrandController::index
* @see app/Http/Controllers/BrandController.php:31
* @route '/brands'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\BrandController::store
* @see app/Http/Controllers/BrandController.php:56
* @route '/brands'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/brands',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BrandController::store
* @see app/Http/Controllers/BrandController.php:56
* @route '/brands'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BrandController::store
* @see app/Http/Controllers/BrandController.php:56
* @route '/brands'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BrandController::edit
* @see app/Http/Controllers/BrandController.php:66
* @route '/brands/{brand}/edit'
*/
export const edit = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/brands/{brand}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BrandController::edit
* @see app/Http/Controllers/BrandController.php:66
* @route '/brands/{brand}/edit'
*/
edit.url = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { brand: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { brand: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            brand: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        brand: typeof args.brand === 'object'
        ? args.brand.id
        : args.brand,
    }

    return edit.definition.url
            .replace('{brand}', parsedArgs.brand.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BrandController::edit
* @see app/Http/Controllers/BrandController.php:66
* @route '/brands/{brand}/edit'
*/
edit.get = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BrandController::edit
* @see app/Http/Controllers/BrandController.php:66
* @route '/brands/{brand}/edit'
*/
edit.head = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\BrandController::update
* @see app/Http/Controllers/BrandController.php:74
* @route '/brands/{brand}'
*/
export const update = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '/brands/{brand}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\BrandController::update
* @see app/Http/Controllers/BrandController.php:74
* @route '/brands/{brand}'
*/
update.url = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { brand: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { brand: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            brand: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        brand: typeof args.brand === 'object'
        ? args.brand.id
        : args.brand,
    }

    return update.definition.url
            .replace('{brand}', parsedArgs.brand.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BrandController::update
* @see app/Http/Controllers/BrandController.php:74
* @route '/brands/{brand}'
*/
update.put = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\BrandController::update
* @see app/Http/Controllers/BrandController.php:74
* @route '/brands/{brand}'
*/
update.patch = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\BrandController::destroy
* @see app/Http/Controllers/BrandController.php:84
* @route '/brands/{brand}'
*/
export const destroy = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/brands/{brand}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\BrandController::destroy
* @see app/Http/Controllers/BrandController.php:84
* @route '/brands/{brand}'
*/
destroy.url = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { brand: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { brand: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            brand: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        brand: typeof args.brand === 'object'
        ? args.brand.id
        : args.brand,
    }

    return destroy.definition.url
            .replace('{brand}', parsedArgs.brand.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BrandController::destroy
* @see app/Http/Controllers/BrandController.php:84
* @route '/brands/{brand}'
*/
destroy.delete = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\RestoreBrandController::__invoke
* @see app/Http/Controllers/RestoreBrandController.php:20
* @route '/brands/{brand}/restore'
*/
export const restore = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: restore.url(args, options),
    method: 'put',
})

restore.definition = {
    methods: ["put"],
    url: '/brands/{brand}/restore',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\RestoreBrandController::__invoke
* @see app/Http/Controllers/RestoreBrandController.php:20
* @route '/brands/{brand}/restore'
*/
restore.url = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { brand: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { brand: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            brand: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        brand: typeof args.brand === 'object'
        ? args.brand.id
        : args.brand,
    }

    return restore.definition.url
            .replace('{brand}', parsedArgs.brand.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\RestoreBrandController::__invoke
* @see app/Http/Controllers/RestoreBrandController.php:20
* @route '/brands/{brand}/restore'
*/
restore.put = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: restore.url(args, options),
    method: 'put',
})

const brands = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    restore: Object.assign(restore, restore),
    accounts: Object.assign(accounts, accounts),
    settings: Object.assign(settings, settings),
    audits: Object.assign(audits, audits),
}

export default brands